import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

export const api = axios.create({
    baseURL: API_URL,
    headers: { 'Content-Type': 'application/json' }
});

// Interceptor para anexar token JWT do usuário
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('ag_token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export default api;
